<template>
    <EmployeeViewPaymentLiquidation></EmployeeViewPaymentLiquidation>
</template>
<script>
    import EmployeeViewPaymentLiquidation from '@/components/EmployeeViewPaymentLiquidation.vue'
    export default {
        name: 'employee-view-payment-liquidation',
        components: {
            EmployeeViewPaymentLiquidation
        }
    }
</script>